(
    function (skyward, $, undefined) {
        skyward.userform = skyward.userform || {};

        var init = function (selector)
        {
            let outerFormContainer = document.getElementById('FormViewerBody');
            if (outerFormContainer){
                let wrapper = document.getElementById('formViewerSizeContainer');
                if (wrapper) {
                    window.addEventListener("resize", resize);
                    resize();
                    function resize(){
                        let maxWidth  = outerFormContainer.clientWidth,
                        maxHeight = outerFormContainer.clientHeight;

                        let scale = 1.0,
                        width = wrapper.clientWidth;
                        scale = (maxWidth/width);

                        if (scale > 1.0){
                            scale = 1.0;
                        }
                        outerFormContainer.style.transform = 'scale(' + scale + ')';
                    }
                }
            }
        };

        var specificationPopup = function ()
        {
            var button = $(this);
            var options =
            {
                anchorTo: button,
                id: button.attr('id'),
                draggable: false,
                initialFocusElement: button
            };

            if (button.find("div:not(.linkTypeDivOverlay)").html() == "")
            {
                return;
            }

            var toggleRequiredStyle = function (required) {
                if (required) {
                    button.addClass('required');
                }
                else {
                    button.removeClass('required');
                }
            }

            var action = "GetFormFieldSpecification?renderType=contentOnly";
            var formVersionID = button.data().formVersionId;
            var userFormVersionID = button.data().userFormVersionId;
            var allowEdit = (button.data().allowEdit.toLowerCase() === "true");

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Form/FormField/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        FormFieldSkywardID: button.data().formFieldId,
                        FormVersionID: formVersionID,
                        UserFormVersionID: userFormVersionID,
                        RadioValue: button.data().radioValue,
                        RelationshipUniqueID: button.data().relationshipUniqueId,
                        RelationshipNumber: button.data().relationshipNumber,
                        SignatureNameID: button.data().signatureNameId,
                        AllowEdit: allowEdit,
                    }
                });
            };

            $.when(buildPopup()).done(function (html)
            {
                const buttons = [
                    { id: "closeButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" }
                ];

                if (allowEdit) {
                    buttons.push({ id: "saveFormFieldVersion", text: "Save", click: saveData, icon: "Save", data: button.data() });
                }

                var dialog = skyward.modalLayer.showDialog('Form Field Details', html, buttons, options);

                function saveData() {
                    var selector = "#formFieldVersionPopupContent";
                    var container = $(selector);
                    var action = skyward.controls.getValue(container.find("#SpecificationPopupSaveAction"));

                    $.ajax({
                        url: skyward.global.virtualDir + "Form/FormFieldVersion/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: {
                            FormFieldVersionID: skyward.controls.getValue(container.find("#FormFieldVersionID")),
                            UserFormFieldVersionID: skyward.controls.getValue(container.find("#UserFormFieldVersionID")),
                            EditableInActivityAccess: skyward.controls.getValue(container.find("#EditableInActivityAccess")),
                            EditableInAdministrativeAccess: skyward.controls.getValue(container.find("#EditableInAdministrativeAccess")),
                            EditableInEmployeeAccess: skyward.controls.getValue(container.find("#EditableInEmployeeAccess")),
                            EditableInFamilyAccess: skyward.controls.getValue(container.find("#EditableInFamilyAccess")),
                            EditableInNewStudentEnrollment: skyward.controls.getValue(container.find("#EditableInNewStudentEnrollment")),
                            EditableInStudentAccess: skyward.controls.getValue(container.find("#EditableInStudentAccess")),
                            EditableInStudentServices: skyward.controls.getValue(container.find("#EditableInStudentServices")),
                            EditableInTeacherAccess: skyward.controls.getValue(container.find("#EditableInTeacherAccess")),
                            IsRequired: skyward.controls.getValue(container.find("#IsRequired")),
                            AutoFillGuardianSignature: skyward.controls.getValue(container.find("#AutoFillGuardianSignature")),
                            DefaultValue: skyward.controls.getValue(container.find("#DefaultValue")),
                        },
                        success: function (response)
                        {
                            toggleRequiredStyle(skyward.controls.getValue(container.find("#IsRequired")));
                            dialog.close();
                        }
                    });
                }

            });
        };

        ////Bootstrap
        var events =
        {
            "specificationPopup": specificationPopup
        };
        skyward.events.registerEvents("userform", events);
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
